export default __webpack_public_path__ + "static/media/edit.0fcbfe2f.svg";